<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Referral claim report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Referral claim report</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'RefClaimList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Full name</strong> {{ value.full_name }}</li>

                  <li><strong>Username</strong> {{ !_.isEmpty(value.referrer) ? value.referrer.username : '-' }}</li>

<!--                  <li><strong>NID no</strong> {{ value.nid_number }}</li>-->

                  <li><strong>Email</strong> {{ value.email }}</li>

                  <li><strong>bKash</strong> {{ value.mobile_bank }}</li>

<!--                  <li><strong>Points</strong> {{ value.points | number_format }}</li>-->

                  <li><strong>Amount</strong> {{ value.earning | number_format }}</li>

                  <li><strong>Status</strong> {{ value.status }}</li>

                  <li><strong>Notes</strong> {{ value.notes }}</li>

                  <li><strong>Created by</strong> {{ value.created_by }}</li>

                  <li><strong>Updated by</strong> {{ value.updated_by }}</li>

                  <li><strong>Created at</strong> {{ value.created_at | moment }}</li>

                  <li><strong>Updated at</strong> {{ value.updated_at | moment }}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from 'axios'
import {Notification} from 'element-ui'

const fileDownload = require("js-file-download")


export default {
  name: 'RefClaimShow',
  metaInfo: {
    title: 'Ref Claim | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })
      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({title: 'Download Failed', message: 'Failed to download', type: 'error'})
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/ref_claims/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {
          })
      })
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a")
    },
    number_format: function (value) {
      return new Intl.NumberFormat('BDT', {currency: 'BDT', minimumFractionDigits: 2}).format(value)
    },
  }
}
</script>
